<template>
    <div class="text-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="action-button"
          >
            Action
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="manageDetach" class="read-list-items" >
            <v-list-item-title>Detach</v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>
    </div>
  </template>

<script>

import Api from "@/objects/api";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  name: "BreadTabulatorActionDetachButton",
  
  computed: mapState({
    auth: (state) => state.auth.data,
    services: (state) => state.service.data.services,
    rolePermission: (state) => state.rolePermission.data,
  }),

  props: { 
    cellData: {},
    cellValue: {},
    cellRowData: {},
    serviceKey: {},
    parentModelKey: {},
    parentModelId: {},
    intermediateModelKey: {},
    intermediateModelId: {},
    childModelKey: {},
  },

  data: () => ({
    model: new Model(),
    service: new Service(),
    api: new Api(),
    manageDetachButton: null,
    isTeamAdmin: false,
    adminCount: 0,
    viewId: null,
    timestampDeleted: null,
  }),

  created() {
    this.model.getByKey(this.modelKey);
    this.viewId = this.$route.query.viewId;
    this.timestampDeleted = this.cellRowData.timestampDeleted;

  },

  mounted() {
    //
  },

  methods: {
    /**
     * Detach confirms over the list where the tab hosts a dialog, and routes to
     * the detach page where it doesn't (the legacy dev-model Tabulator pages).
     *
     * This component is mounted imperatively by a model's column formatter, so
     * it has no parent to $emit to — the store is the only channel it shares
     * with the list it is drawn in. See store/modules/modelDetachDialog.js.
     *
     * The row goes along because it already carries both sides of the relation
     * (`{ InternalRole, InternalUser }`), which is what lets the dialog name
     * what is being detached from what without a second read.
     */
    manageDetach(){
      const dialog = this.$store.state.modelDetachDialog;
      if (dialog && dialog.data.hostCount > 0) {
        this.$store.dispatch("requestModelDetach", {
          serviceKey: this.serviceKey,
          parentModelKey: this.parentModelKey,
          parentModelId: this.parentModelId,
          intermediateModelKey: this.intermediateModelKey,
          intermediateModelId: this.intermediateModelId,
          childModelKey: this.childModelKey,
          row: this.cellRowData,
        });
        return;
      }

      this.$router.push({
          name: "PageServiceModelBreadTabulatorChildDetach",
          params: {
            serviceKey: this.serviceKey,
            parentModelKey: this.parentModelKey,
            parentModelId: this.parentModelId,
            intermediateModelKey: this.intermediateModelKey,
            intermediateModelId: this.intermediateModelId,
            childModelKey: this.childModelKey,
          },
        });
    },

  }
};
</script>

<style>
.action-button {
  width: 90% !important;
  height: 100% !important;
}

.read-list-item{
    color: #ffffff !important;
    background-color: #1976d2;
}

.edit-list-item{
    color: #ffffff !important;
    background-color: green;
}

.delete-list-item{
    color: #ffffff !important;
    background-color: rgb(128, 0, 0);
}
</style>